export default __webpack_public_path__ + "static/media/Rectangle 96.f34c6796.png";